/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext, useState } from 'react';

import { Tab, TabContext, TabPanel, Tabs } from '@coursera/cds-core';

import LoadingSpinner from 'bundles/grading/components/common/LoadingSpinner';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import SubmitterListGroup from 'bundles/grading/components/staff-graded-assignments/left-panel/SubmitterListGroup';
import { hasSubmission } from 'bundles/grading/utils/submissionUtils';

import _t from 'i18n!nls/grading';

const styles = {
  container: css`
    width: 100%;
    display: flex;
    flex-flow: column;
    height: 100%;
  `,
  tabs: css`
    margin: 0 var(--cds-spacing-200) var(--cds-spacing-200) var(--cds-spacing-200);
  `,
  tabPanels: css`
    flex-grow: 1;
    overflow-y: auto;
  `,
};

type TabValue = 'submitted' | 'not-submitted';

// Component for list of submitters
const Submitters = () => {
  const { submitterList } = useContext(SGAPageContext);

  const { currentSubmitter, submittedGroup, notSubmittedGroup } = submitterList.data || {};

  const currentTab =
    (currentSubmitter && !hasSubmission(currentSubmitter.submittedAt)) || !submittedGroup?.length
      ? 'not-submitted'
      : 'submitted';

  const [tab, setTab] = useState<TabValue>(currentTab);

  if (submitterList.loading) {
    return <LoadingSpinner />;
  }
  if (submitterList.error || !submitterList.data) {
    return null;
  }
  return (
    <TabContext value={tab}>
      <div css={styles.container}>
        <Tabs
          variant="section"
          aria-label={_t('Groups of learners by submitted status')}
          onChange={(val) => setTab(val as TabValue)}
          css={styles.tabs}
        >
          <Tab label={_t(`Submitted (#{num})`, { num: (submittedGroup || []).length })} value="submitted" />
          <Tab label={_t(`Not submitted (#{num})`, { num: (notSubmittedGroup || []).length })} value="not-submitted" />
        </Tabs>
        <div css={styles.tabPanels}>
          <TabPanel value="submitted" style={{ height: '100%' }}>
            <SubmitterListGroup items={submittedGroup || []} current={currentSubmitter} />
          </TabPanel>
          <TabPanel value="not-submitted" style={{ height: '100%' }}>
            <SubmitterListGroup items={notSubmittedGroup || []} current={currentSubmitter} />
          </TabPanel>
        </div>
      </div>
    </TabContext>
  );
};

export default Submitters;
